import SiteShell from "@/components/feature/SiteShell";
import JsonLd from "@/components/feature/JsonLd";
import useSeo from "@/hooks/useSeo";
import Hero from "@/pages/home/components/Hero";
import FocusSection from "@/pages/home/components/FocusSection";
import CategoryGrid from "@/pages/home/components/CategoryGrid";
import LatestSection from "@/pages/home/components/LatestSection";
import TimelineSection from "@/pages/home/components/TimelineSection";
import FaqPreview from "@/pages/home/components/FaqPreview";
import SubscribeSection from "@/pages/home/components/SubscribeSection";

const Home = () => {
  useSeo({
    title: "考古坞 - 热门黑料历史回顾｜旧料翻出·考古合集",
    description:
      "考古坞整理娱乐往事，做热门黑料历史回顾与旧料翻出。选秀记忆、影视旧账、乐坛回响、网络初代，按年代归档的考古合集，附出处考证，旧料翻出来重新看。",
    keywords: "热门黑料,热门黑料历史回顾,热门黑料旧料翻出,热门黑料考古合集",
    image:
      "https://readdy.ai/api/search-image?query=vintage%20archive%20room%20interior%20with%20tall%20wooden%20shelves%20of%20labeled%20boxes%2C%20stacked%20film%20reels%20and%20bundled%20old%20newspapers%2C%20warm%20amber%20light%20rays%20with%20floating%20dust%2C%20deep%20brick%20red%20and%20aged%20gold%20color%20grading%2C%20moody%20cinematic%20atmosphere%2C%20artistic%20stylized%2C%20no%20people&width=1600&height=900&seq=arch-hero-2026&orientation=landscape",
  });

  const structuredData = [
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "考古坞",
      alternateName: "娱乐往事档案室",
      url: "https://kaogudock.cn",
      description:
        "考古坞是一个专注娱乐往事整理的档案室，对热门黑料历史回顾、旧料翻出与考古合集做年代考证。",
      email: "hello@kaogudock.cn",
    },
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: "考古坞",
      url: "https://kaogudock.cn",
      inLanguage: "zh-CN",
      potentialAction: {
        "@type": "SearchAction",
        target: "https://kaogudock.cn/archive?q={search_term_string}",
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "WebPage",
      name: "热门黑料历史回顾 - 考古坞",
      description:
        "按年代归档的娱乐往事合集，涵盖选秀记忆、影视旧账、乐坛回响、网络初代四个主题。",
      inLanguage: "zh-CN",
      isPartOf: { "@type": "WebSite", name: "考古坞", url: "https://kaogudock.cn" },
    },
  ];

  return (
    <SiteShell>
      <JsonLd data={structuredData} />
      <Hero />
      <FocusSection />
      <CategoryGrid />
      <LatestSection />
      <TimelineSection />
      <FaqPreview />
      <SubscribeSection />
    </SiteShell>
  );
};

export default Home;